module.exports = __webpack_public_path__ + "media/newstyle/images/correcoes2-25ff6e6cd522313c5cb86f6ce1fa1ca5.png";